/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never;
    };
import type * as Types from './graphql.schema-types';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export * from './graphql.schema-types';
export type GetChatMessagesQueryVariables = Exact<{
  organizationId: string;
  offset?: number | null | undefined;
  limit?: number | null | undefined;
  conversationId: string;
}>;

export type GetChatMessagesQuery = {
  getSupportChatMessages: Array<{
    authorId: string | null;
    comment: string | null;
    date: number | null;
    type: Types.CommnetType | null;
    standaloneSupportMessageId: string | null;
  } | null> | null;
};

export type DownloadAllQueryVariables = Exact<{
  messageId: string;
}>;

export type DownloadAllQuery = { getAttachmentDownloadTask: string | null };

export const GetChatMessagesDocument = gql`
  query getChatMessages(
    $organizationId: ID!
    $offset: Int
    $limit: Int
    $conversationId: ID!
  ) {
    getSupportChatMessages(
      organizationId: $organizationId
      conversationId: $conversationId
      offset: $offset
      limit: $limit
    ) {
      authorId
      comment
      date
      type
      standaloneSupportMessageId
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetChatMessagesGQL extends Apollo.Query<
  GetChatMessagesQuery,
  GetChatMessagesQueryVariables
> {
  document = GetChatMessagesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const DownloadAllDocument = gql`
  query downloadAll($messageId: ID!) {
    getAttachmentDownloadTask(messageId: $messageId)
  }
`;

@Injectable({
  providedIn: 'root',
})
export class DownloadAllGQL extends Apollo.Query<
  DownloadAllQuery,
  DownloadAllQueryVariables
> {
  document = DownloadAllDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
